import { useTranslation } from 'react-i18next';
import { FIRST_SPIN_REWARD_FS, getSecondOfferFs } from '../../helpers';
import { ScOfferButton, ScOfferTitles } from '../OfferCard/styled';
import {
  ScOfferPlusReveal,
  ScOfferPrizeAmount,
  ScOfferPrizeLabel,
  ScOfferPrizes,
  ScOfferSecondPrizeReveal,
  ScSecondStageOffer,
} from './styled';

interface IPrizeProps {
  label: string;
  amount: string;
}

const Prize = ({ label, amount }: IPrizeProps) => (
  <ScOfferTitles>
    <ScOfferPrizeLabel>{label}</ScOfferPrizeLabel>
    <ScOfferPrizeAmount data-text={amount}>{amount}</ScOfferPrizeAmount>
  </ScOfferTitles>
);

interface ISecondStageOfferProps {
  fsCount: number;
  onShowFinalOffer: () => void;
  translation: string;
}

export const SecondStageOffer = ({
  fsCount,
  onShowFinalOffer,
  translation,
}: ISecondStageOfferProps) => {
  const { t } = useTranslation(translation);

  const secondSpinFS = getSecondOfferFs(fsCount);

  return (
    <ScSecondStageOffer>
      <ScOfferPrizes>
        <Prize
          amount={t('fs', { fsCount: FIRST_SPIN_REWARD_FS })}
          label={t('firstPrize.label')}
        />
        <ScOfferPlusReveal>
          <ScOfferPrizeAmount data-text="+">+</ScOfferPrizeAmount>
        </ScOfferPlusReveal>
        <ScOfferSecondPrizeReveal>
          <Prize
            amount={t('fs', { fsCount: secondSpinFS })}
            label={t('secondPrize.label')}
          />
        </ScOfferSecondPrizeReveal>
      </ScOfferPrizes>
      <ScOfferButton onClick={onShowFinalOffer} type="button">
        {t('stage2.offer.cta')}
      </ScOfferButton>
    </ScSecondStageOffer>
  );
};
